import { useEffect, useState } from "react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { formatINR, formatDate } from "@/lib/constants";
import { useAuth } from "@/context/AuthContext";
import { LeadDetail } from "@/components/LeadDetail";
import { ClipboardCheck, Eye } from "lucide-react";

export default function OpsApproval() {
  const { user } = useAuth();
  const [leads, setLeads] = useState([]);
  const [lenders, setLenders] = useState([]);
  const [partners, setPartners] = useState([]);
  const [docTypes, setDocTypes] = useState([]);
  const [detailLead, setDetailLead] = useState(null);
  const canDecide = user?.role === "admin" || user?.role === "operations_manager";
  const load = () => api.get("/leads").then((r) => setLeads((r.data || []).filter((l) => l.status === "Ops Approval" || l.status === "Sent for PDD Approval"))).catch(() => {});
  useEffect(() => {
    load();
    api.get("/lenders").then((r) => setLenders(r.data)).catch(() => {});
    api.get("/partners").then((r) => setPartners(r.data)).catch(() => {});
    api.get("/settings/lead").then((r) => setDocTypes(r.data.doc_types || [])).catch(() => {});
  }, []);
  return (
    <div className="space-y-5" data-testid="ops-approval-page">
      <div>
        <h1 className="text-2xl sm:text-3xl font-extrabold text-slate-900 font-heading tracking-tight flex items-center gap-2"><ClipboardCheck size={24} className="text-emerald-600" /> Ops Approval Inbox</h1>
        <p className="text-sm text-slate-500 mt-1">Leads pending your review — {canDecide ? "approve or reject after checking the PDD checklist." : "you can view but only Operations Manager can decide."}</p>
      </div>
      <div className="rounded-xl border border-slate-200 overflow-hidden bg-white shadow-sm overflow-x-auto">
        <table className="w-full min-w-[720px]">
          <thead>
            <tr className="bg-slate-50 text-xs font-semibold uppercase tracking-wider text-slate-500 border-b border-slate-200">
              <th className="text-left px-4 py-3">Customer</th>
              <th className="text-left px-4 py-3">Loan Type</th>
              <th className="text-right px-4 py-3">Amount</th>
              <th className="text-left px-4 py-3">Lender</th>
              <th className="text-left px-4 py-3">Submitted By</th>
              <th className="text-left px-4 py-3">Submitted At</th>
              <th className="text-right px-4 py-3">Action</th>
            </tr>
          </thead>
          <tbody>
            {leads.map((l) => (
              <tr key={l.id} data-testid={`ops-approval-row-${l.id}`} className="border-b border-slate-100 text-sm text-slate-700">
                <td className="px-4 py-3 font-medium text-slate-900">{l.customer_name}</td>
                <td className="px-4 py-3">{l.pdd?.loan_type || l.loan_type}</td>
                <td className="px-4 py-3 text-right font-mono">{formatINR(l.loan_amount)}</td>
                <td className="px-4 py-3">{l.lender_name || "—"}</td>
                <td className="px-4 py-3">{l.pdd?.submitted_by || "—"}</td>
                <td className="px-4 py-3">{l.pdd?.submitted_at ? formatDate(l.pdd.submitted_at) : "—"}</td>
                <td className="px-4 py-3 text-right">
                  <button data-testid={`open-lead-${l.id}`} onClick={() => setDetailLead(l)} className="p-2 rounded-lg text-slate-500 hover:text-emerald-600 hover:bg-emerald-50 inline-flex items-center gap-1"><Eye size={14} /> Review</button>
                </td>
              </tr>
            ))}
            {leads.length === 0 && <tr><td colSpan={7} className="px-4 py-12 text-center text-slate-400 text-sm">No leads pending Ops Approval.</td></tr>}
          </tbody>
        </table>
      </div>
      {detailLead && <LeadDetail lead={detailLead} lenders={lenders} partners={partners} docTypes={docTypes} onClose={() => setDetailLead(null)} onChange={load} />}
    </div>
  );
}
